import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import Container from './components/Container';
import { ResponsiveContext } from './context';
import ResponsiveTools from './utils/responsive';
// import reportWebVitals from './reportWebVitals';

const {
  webResponsiveUtil: webRT,
  mobileResponsiveUtil: mobileRT,
  isMobile,
} = ResponsiveTools;

ReactDOM.render(
  <React.StrictMode>
    <ResponsiveContext.Provider
      value={{
        isMobile,
        webRT,
        mobileRT,
      }}
    >
      <App>
        <Container />
      </App>
    </ResponsiveContext.Provider>
  </React.StrictMode>,
  document.getElementById('irobot-embedded-product-demo')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
